import React from 'react'

// Appt Components
import Select from '../../../components/simple/input/Select'
import { capitalize } from '../../../utils/text'

import LocalStorageService from '../../../services/LocalStorageService'

import constants from '../../../utils/constants'

const FieldBox = (props) => {
  // replace the name of the service user with the stored term
  const terms = LocalStorageService.get('terms')

  let serviceUserLabel = capitalize(terms?.serviceUser || 'Service User')

  var searchFields = []
  for (var thisField of constants.reportSearch) {
    if (thisField?.label.includes('[Student]')) {
      thisField.label = thisField.label.replace('[Student]', serviceUserLabel)
    }
    searchFields.push(thisField)
  }

  if (props.reportType === 'Log') {
    searchFields = searchFields.filter(field => field.label.startsWith('Log -'))
  } else if (props.reportType === 'Clicker') {
    searchFields = searchFields.filter(field => field.label.startsWith('Clicker -') || field.label.startsWith(`${serviceUserLabel} -`))
  } else {
    searchFields = searchFields.filter(field => !field.label.startsWith('Log -'))
    searchFields = searchFields.filter(field => !field.label.startsWith('Clicker -'))
  }

  return (
    <>
      <Select
        {...props}
        // name='reportSearch'
        labelKey='label'
        onChange={({ value: nextValue }) => {
          props.handleFieldChanged(props.name, nextValue)
        }}
        options={searchFields}
        valueKey={{ key: 'value' }}
      />
    </>
  )
}

export default FieldBox
